module.exports = __webpack_public_path__ + "static/media/check_mark_grey.0a070626.svg";